import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
  },
  categories: {
    width: '100%',
    paddingTop: 0,
    overflowY: 'auto',
  },
  categoryItem: {
    border: `1px solid ${neutral['20']}`,
    '&:hover': {
      backgroundColor: neutral['10'],
    },
  },
  categoryItemTextPrimary: {
    marginLeft: '0.5rem',
    fontWeight: 500,
    color: neutral[100],
  },

  customizationsContainer: {
    width: '100%',
    overflowY: 'auto',
  },
  customizationsTitle: {
    padding: '1rem',
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
    color: neutral[100],
  },
});
